














import { Vue, Component, Watch } from 'vue-property-decorator'
import { getPapers, paperDoc, getSourceAddress } from '../../models/api'
import { PaperItem } from '@/components'

const position = '高考专题'

@Component({
  components: {
    PaperItem
  }
})
export default class HigherList extends Vue {
  private list = []
  public currentPaper: any = {}
  public visible = false

  private get userInfo() {
    return this.$store.state.user_info
  }

  public get userName() {
    return this.$store.state.user_info && this.$store.state.user_info.nickname
  }

  public get subject() {
    return this.$store.state.subject
  }

  public get moduleName() {
    return this.$route.meta.label
  }

  @Watch('userInfo', { deep: true })
  onUserChange(val, old) {
    this.renderList()
  }

  mounted() {
    this.renderList()
  }

  public async renderList() {
    const { ids }: any = this.$route.query
    const paper_ids = ids.split(',')

    const { data, success }: any = await getPapers({ paper_ids })

    if (success) {
      this.list = data
    }
  }

  public clickDownload(val: any) {
    this.currentPaper = val
    if (!this.userName) {
      this.$store.commit('SET_LOGINMODAL', true)
      return
    }

    let param = val
    if (val.is_excellent) {
      window['sensors'].track('TIKU_Download', {
        proSource: this.moduleName,
        content: '试卷',
        paper_subject: val.subject_text,
        is_not: '是'
      })
    } else {
      window['sensors'].track('TIKU_Download', {
        proSource: this.moduleName,
        content: '试卷',
        paper_subject: val.subject_text,
        is_not: '否'
      })
    }

    this.getPaperDoc(val.paper_id, param)
  }

  public async getPaperDoc(val, obj?: any) {
    let count = 0
    let req: any = {
      subject_id: this.subject.value,
      paper_id: val
    }
    if (obj) {
      req = Object.assign({}, req, obj)
    }
    // this.loadingModal = true
    try {
      const data: any = await paperDoc(req)
      if (data.error && data.error == '请登录') {
        this.visible = false
        this.$store.commit('SET_LOGINMODAL', true)
      }
      if (data.success) {
        this.getSource(data.data.task_id, count, req.subject_id, val, '')
      }
    } catch (e) {
      // this.loadingModal = false
    }
  }

  public async getSource(
    task_id: string | number,
    count: number,
    subject_id: string,
    paper_id: string,
    home?: string
  ) {
    try {
      let { data } = await getSourceAddress(task_id)
      if (data.success) {
        // if (this.loadingModal) {
        //   this.loadingModal = false
        // }
        let temp = '/finish' + `?subject_id=${subject_id}&paper_id=${paper_id}`
        temp = temp + `&url=${data.data.download_url}&home=${home}`
        setTimeout(() => {
          window.open(temp)
        }, 50)
      } else {
        if (count > 3000) {
          // loading = false
          // if (this.loadingModal) {
          //   this.loadingModal = false
          // }
          this.$message.warning('请求超时，请重新下载！')
        } else {
          count = count + 1
          // 失败之后1秒以后查询
          setTimeout(() => {
            this.getSource(task_id, count, subject_id, paper_id, home)
          }, 1000)
        }
      }
    } catch (e) {
      // if (this.loadingModal) {
      //   this.loadingModal = false
      // }
      console.log(e)
    }
  }
}
